import React, {Component} from "react";
import TitleCont from "../recipes/titleCont";

class WinnersTitle extends Component {
    render() {
        const {title,subtitle} = this.props;
        return (
            <>
                <TitleCont title={title} subtitle={subtitle}/>
            </>
        )
    }
}

export default WinnersTitle;